// Horizontal carousels ([data-drag-scroll]): click-and-drag (grab cursor) +
// prev/next arrows; touch devices swipe natively. The wheel is deliberately NOT
// hijacked — vertical scrolling always belongs to the page (Lenis), so a
// carousel never traps the scroll.
const DRAG_THRESHOLD = 5; // px of travel before a press counts as a drag

document.querySelectorAll('[data-drag-scroll]').forEach((el) => {
  let down = false;
  let dragging = false;
  let startX = 0;
  let startScroll = 0;

  // Nothing is prevented or captured here: preventDefault() on pointerdown
  // suppresses the compatibility mouse events, and pointer capture retargets the
  // click to this scroller instead of the card underneath. Either one on its own
  // stops a plain click from ever reaching the card's <a>. Both wait until the
  // pointer has actually travelled (below), by which point it IS a drag and
  // swallowing the click is the whole point.
  el.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse') return;
    down = true;
    dragging = false;
    startX = e.pageX;
    startScroll = el.scrollLeft;
  });

  el.addEventListener('pointermove', (e) => {
    if (!down) return;

    const dx = e.pageX - startX;
    if (!dragging) {
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      dragging = true;
      el.classList.add('is-dragging');
      el.setPointerCapture(e.pointerId); // keep receiving moves outside the element
    }

    el.scrollLeft = startScroll - dx;
  });

  const stop = (e) => {
    if (!down) return;
    down = false;
    el.classList.remove('is-dragging');
    if (e && e.pointerId != null && el.hasPointerCapture(e.pointerId)) {
      el.releasePointerCapture(e.pointerId);
    }
  };
  el.addEventListener('pointerup', stop);
  el.addEventListener('pointercancel', stop);

  // Native image drag would otherwise start a ghost-drag mid-swipe. This is what
  // the old pointerdown preventDefault() was really for, and cancelling it here
  // leaves the click untouched.
  el.addEventListener('dragstart', (e) => e.preventDefault());

  // Swallow the click that ends a drag so it doesn't follow the card link.
  el.addEventListener(
    'click',
    (e) => {
      if (dragging) {
        e.preventDefault();
        e.stopPropagation();
        dragging = false;
      }
    },
    true
  );
});

// Prev/next arrow buttons ([data-scroll="prev"|"next"]) scroll the sibling carousel.
document.querySelectorAll('[data-scroll]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const scroller = btn.parentElement.querySelector('[data-drag-scroll]');
    if (!scroller) return;
    const amount = scroller.clientWidth * 0.75;
    scroller.scrollBy({ left: btn.dataset.scroll === 'prev' ? -amount : amount, behavior: 'smooth' });
  });
});
